import axios from "axios";
import cloneDeep from "lodash/cloneDeep";

const state = {
  FreeShippings:null,
  loading:false
};

const getters = {
  getFreeShippings(state) {
    return state.FreeShippings;
  },
  getFreeShippingsLoading(state) {
    return state.loading;
  },

};

const mutations = {
  setFreeShippings(state, product) {
    state.FreeShippings = product;
  },
  setFreeShippingsLoading(state,flag) {
    state.loading = flag;
  },

  
 
};

const actions = {
  
  async getDataFreeShippings({ commit, state },query) {
    console.log(query,"queryqueryquery");
    commit("setFreeShippingsLoading", true);
     await axios.get(`front/products?free_shipping=1&page=${query.page}`).then((response)=>{
      console.log(response.data.data.products,"response.data.data.products");
       commit("setFreeShippings", response.data.data.products);
       setTimeout(() => {
        document.documentElement.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    }).catch(error=>{
    console.log(error);

    }).finally(()=>{

    commit("setFreeShippingsLoading", false);
    })


  },

};

export default {
  state,
  getters,
  mutations,
  actions,
};
